// Example implementation of validateMeasurements
export const validateMeasurements = (measurements) => {
  console.log("Validating measurements:", measurements);
  
  // Check if all required measurements exist and are numbers
  const requiredFields = ['bust', 'waist', 'hips', 'inseam', 'shoulders'];
  
  for (const field of requiredFields) {
    if (typeof measurements[field] !== 'number' || isNaN(measurements[field]) || measurements[field] <= 0) {
      console.error(`Invalid ${field} measurement:`, measurements[field]);
      return {
        valid: false,
        message: `Invalid ${field} measurement. Please try again with a clearer image.`
      };
    }
  }
  
  // Additional validation could be added here
  // For example, check if measurements are within reasonable ranges
  
  return {
    valid: true,
    message: "Measurements are valid"
  };
};

// Example implementation of determineSizeFromMeasurements
export const determineSizeFromMeasurements = (measurements) => {
  console.log("Determining size from measurements:", measurements);
  
  // Simple size chart (this would be more complex in a real application)
  const sizeChart = {
    'XS': { minBust: 30, maxBust: 32, minWaist: 23, maxWaist: 25, minHips: 33, maxHips: 35 },
    'S':  { minBust: 33, maxBust: 35, minWaist: 26, maxWaist: 28, minHips: 36, maxHips: 38 },
    'M':  { minBust: 36, maxBust: 38, minWaist: 29, maxWaist: 31, minHips: 39, maxHips: 41 },
    'L':  { minBust: 39, maxBust: 41, minWaist: 32, maxWaist: 34, minHips: 42, maxHips: 44 },
    'XL': { minBust: 42, maxBust: 44, minWaist: 35, maxWaist: 37, minHips: 45, maxHips: 47 },
    'XXL': { minBust: 45, maxBust: 47, minWaist: 38, maxWaist: 40, minHips: 48, maxHips: 50 }
  };
  
  // Determine size based on bust, waist, and hips
  let sizeScores = {
    'XS': 0, 'S': 0, 'M': 0, 'L': 0, 'XL': 0, 'XXL': 0
  };
  
  // Check where each measurement falls in the size chart
  for (const size in sizeChart) {
    const sizeRange = sizeChart[size];
    
    if (measurements.bust >= sizeRange.minBust && measurements.bust <= sizeRange.maxBust) {
      sizeScores[size]++;
    }
    
    if (measurements.waist >= sizeRange.minWaist && measurements.waist <= sizeRange.maxWaist) {
      sizeScores[size]++;
    }
    
    if (measurements.hips >= sizeRange.minHips && measurements.hips <= sizeRange.maxHips) {
      sizeScores[size]++;
    }
  }
  
  // Find the size with the highest score
  let bestSize = 'M'; // Default to Medium if no clear match
  let highestScore = 0;
  
  for (const size in sizeScores) {
    if (sizeScores[size] > highestScore) {
      highestScore = sizeScores[size];
      bestSize = size;
    }
  }
  
  console.log("Size scores:", sizeScores, "Best size:", bestSize);
  return bestSize;
};